import { twMerge } from "tailwind-merge";
import { motion } from "framer-motion";

export type Props = {
  children: React.ReactNode;
  className?: string;
};

export function MotionSlideLeft({ children, className, ...props }: Props) {
  return (
    <motion.div
      initial={{ x: "100%" }}
      animate={{ x: 0 }}
      exit={{ x: "100%" }}
      transition={{ duration: 0.1, ease: "linear" }}
      className={twMerge("", className)}
      {...props}
    >
      {children}
    </motion.div>
  );
}

export default MotionSlideLeft;
